var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlackCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slack-mark 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2438 23.5146C12.2438 25.0556 10.9842 26.3144 9.44221 26.3144C7.90025 26.3144 6.64062 25.0556 6.64062 23.5146C6.64062 21.9737 7.90025 20.7148 9.44221 20.7148H12.2438V23.5146Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6484 23.5146C13.6484 21.9737 14.9081 20.7148 16.45 20.7148C17.992 20.7148 19.2516 21.9737 19.2516 23.5146V30.525C19.2516 32.0659 17.992 33.3247 16.45 33.3247C14.9081 33.3247 13.6484 32.0659 13.6484 30.525V23.5146Z",
    fill: "#E01E5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.45 12.2675C14.9081 12.2675 13.6484 11.0087 13.6484 9.46776C13.6484 7.92679 14.9081 6.66797 16.45 6.66797C17.992 6.66797 19.2516 7.92679 19.2516 9.46776V12.2675H16.45Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.457 13.6797C17.999 13.6797 19.2586 14.9385 19.2586 16.4795C19.2586 18.0204 17.999 19.2793 16.457 19.2793H9.44221C7.90025 19.2793 6.64062 18.0204 6.64062 16.4795C6.64062 14.9385 7.90025 13.6797 9.44221 13.6797H16.457Z",
    fill: "#36C5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.7031 16.4795C27.7031 14.9385 28.9628 13.6797 30.5047 13.6797C32.0467 13.6797 33.3063 14.9385 33.3063 16.4795C33.3063 18.0204 32.0467 19.2793 30.5047 19.2793H27.7031V16.4795Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.2985 16.4781C26.2985 18.0191 25.0389 19.2779 23.4969 19.2779C21.9549 19.2779 20.6953 18.0191 20.6953 16.4781V9.46776C20.6953 7.92679 21.9549 6.66797 23.4969 6.66797C25.0389 6.66797 26.2985 7.92679 26.2985 9.46776V16.4781Z",
    fill: "#2EB67D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.4969 27.7266C25.0389 27.7266 26.2985 28.9854 26.2985 30.5264C26.2985 32.0673 25.0389 33.3261 23.4969 33.3261C21.9549 33.3261 20.6953 32.0673 20.6953 30.5264V27.7266H23.4969Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.4969 26.3144C21.9549 26.3144 20.6953 25.0556 20.6953 23.5146C20.6953 21.9737 21.9549 20.7148 23.4969 20.7148H30.5117C32.0537 20.7148 33.3133 21.9737 33.3133 23.5146C33.3133 25.0556 32.0537 26.3144 30.5117 26.3144H23.4969Z",
    fill: "#ECB22E"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    stroke: "#E5E7EB",
    strokeWidth: 1.33333
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlackCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slack-card-icon.821ec3454514807bba82d5f64a858455.svg";